export class SelfRegistrationFields{
  public static readonly Pan: string = "Pan";
  public static readonly PanVerificationStatus: string = "PanVerificationStatus";
  public static readonly PanVerificationRemarks: string = "PanVerificationRemarks";
  public static readonly FirstName: string = "First Name";
  public static readonly LastName: string = "Last Name";
  }
